import { memo } from "react";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { FormattedMessage } from "react-intl";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import { IconCredit } from "app/pages/.shared/static/icons";
import "./SearchEngineCreditBanner.scss";

const SearchEngineCreditBanner = ({ totalCredit }) => {
	if (!totalCredit) {
		return false;
	}
	return (
		<div className="search-engine-credit-banner" data-testid="search-engine-credit-banner">
			<div className="search-engine-credit-banner__content">
				<div className="search-engine-credit-banner__icon">
					<IconCredit width={12} height={15} />
				</div>
				<span className="search-engine-credit-banner__text">
					<FormattedMessage
						id="search.engine.credit.banner.text"
						values={{
							amount: <AmountContainer amount={totalCredit} />,
						}}
					/>
				</span>
				<FloatingButton
					position="bottom"
					floatingContent={
						<div
							className="search-engine-credit-banner__cgu"
							data-testid="search-engine-credit-icon"
						>
							<div className="search-engine-credit-banner__credit-cgu-title">
								<FormattedMessage id="mycoupons.credit.banner.info.title" />
							</div>
							<div className="search-engine-credit-banner__credit-cgu-description">
								<FormattedMessage id="mycoupons.credit.banner.info.description" />
							</div>
						</div>
					}
					popoverClassName="search-engine-credit-banner__cgu-popover"
					referenceComponent={
						<IconInfo
							width={12}
							height={12}
							className="search-engine-credit-banner__cgu-icon"
							data-testid="search-engine-credit-cgu-icon"
						/>
					}
				/>
			</div>
		</div>
	);
};

SearchEngineCreditBanner.propTypes = {
	totalCredit: PropTypes.any,
};

export default memo(SearchEngineCreditBanner);
